import type React from 'react'
import { Toggle } from './Toggle'

export interface ToggleRowProps {
  checked: boolean
  onChange: (v: boolean) => void
  label: string
  children?: React.ReactNode
}

export function ToggleRow({ checked, onChange, label, children }: ToggleRowProps) {
  return (
    <div className="toggle-row">
      <span className="toggle-row-label">{children ?? label}</span>
      <Toggle checked={checked} onChange={onChange} label={label} />
    </div>
  )
}
